module.exports = __webpack_public_path__ + "static/media/hamburger.ae962523.png";